import { Types } from "../types/Types"

export const setAuthenticatedUser = (jsonData) => ({

    type: Types.authenticatedUser,
    payload: jsonData
}
)